// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/scribe/svc_encounter_schema.proto (package com.diagnocat.scribe, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";
import { CatalogCloneOverride, CatalogCloneResult, CatalogStatus, EncounterSchema, EncounterSchemaSummary, SchemaDocumentRef, SchemaDocumentRefList, SchemaUsageSummary } from "../../model/dto_scribe_catalog_pb.js";

/**
 * @generated from message com.diagnocat.scribe.GetEncounterSchemaReq
 */
export const GetEncounterSchemaReq = proto3.makeMessageType(
  "com.diagnocat.scribe.GetEncounterSchemaReq",
  () => [
    { no: 1, name: "SchemaID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetEncounterSchemaResp
 */
export const GetEncounterSchemaResp = proto3.makeMessageType(
  "com.diagnocat.scribe.GetEncounterSchemaResp",
  () => [
    { no: 1, name: "Schema", kind: "message", T: EncounterSchema },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListEncounterSchemasReq
 */
export const ListEncounterSchemasReq = proto3.makeMessageType(
  "com.diagnocat.scribe.ListEncounterSchemasReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "IncludeDraft", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 100, name: "Offset", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 101, name: "Limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListEncounterSchemasResp
 */
export const ListEncounterSchemasResp = proto3.makeMessageType(
  "com.diagnocat.scribe.ListEncounterSchemasResp",
  () => [
    { no: 1, name: "Schemas", kind: "message", T: EncounterSchemaSummary, repeated: true },
    { no: 2, name: "Total", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListEncounterSchemaUsageReq
 */
export const ListEncounterSchemaUsageReq = proto3.makeMessageType(
  "com.diagnocat.scribe.ListEncounterSchemaUsageReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "IncludeArchived", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListEncounterSchemaUsageResp
 */
export const ListEncounterSchemaUsageResp = proto3.makeMessageType(
  "com.diagnocat.scribe.ListEncounterSchemaUsageResp",
  () => [
    { no: 1, name: "Schemas", kind: "message", T: SchemaUsageSummary, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.CreateEncounterSchemaReq
 */
export const CreateEncounterSchemaReq = proto3.makeMessageType(
  "com.diagnocat.scribe.CreateEncounterSchemaReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "AnalyticsModelSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "Documents", kind: "message", T: SchemaDocumentRef, repeated: true },
    { no: 9, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus), opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.CreateEncounterSchemaResp
 */
export const CreateEncounterSchemaResp = proto3.makeMessageType(
  "com.diagnocat.scribe.CreateEncounterSchemaResp",
  () => [
    { no: 1, name: "Schema", kind: "message", T: EncounterSchema },
  ],
);

/**
 * Fields left unset keep their stored value. Organization ownership cannot be
 * changed here.
 *
 * @generated from message com.diagnocat.scribe.UpdateEncounterSchemaReq
 */
export const UpdateEncounterSchemaReq = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateEncounterSchemaReq",
  () => [
    { no: 1, name: "SchemaID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "AnalyticsModelSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "Documents", kind: "message", T: SchemaDocumentRefList, opt: true },
    { no: 9, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus), opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.UpdateEncounterSchemaResp
 */
export const UpdateEncounterSchemaResp = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateEncounterSchemaResp",
  () => [
    { no: 1, name: "Schema", kind: "message", T: EncounterSchema },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.DeleteEncounterSchemaReq
 */
export const DeleteEncounterSchemaReq = proto3.makeMessageType(
  "com.diagnocat.scribe.DeleteEncounterSchemaReq",
  () => [
    { no: 1, name: "SchemaID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.DeleteEncounterSchemaResp
 */
export const DeleteEncounterSchemaResp = proto3.makeMessageType(
  "com.diagnocat.scribe.DeleteEncounterSchemaResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.RestoreEncounterSchemaReq
 */
export const RestoreEncounterSchemaReq = proto3.makeMessageType(
  "com.diagnocat.scribe.RestoreEncounterSchemaReq",
  () => [
    { no: 1, name: "SchemaID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.RestoreEncounterSchemaResp
 */
export const RestoreEncounterSchemaResp = proto3.makeMessageType(
  "com.diagnocat.scribe.RestoreEncounterSchemaResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.CloneEncounterSchemaReq
 */
export const CloneEncounterSchemaReq = proto3.makeMessageType(
  "com.diagnocat.scribe.CloneEncounterSchemaReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Overrides", kind: "message", T: CatalogCloneOverride, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.CloneEncounterSchemaResp
 */
export const CloneEncounterSchemaResp = proto3.makeMessageType(
  "com.diagnocat.scribe.CloneEncounterSchemaResp",
  () => [
    { no: 1, name: "Result", kind: "message", T: CatalogCloneResult },
  ],
);

